import { render } from "./ResourcesGoal3a.vue?vue&type=template&id=455a864d"
import script from "./ResourcesGoal3a.vue?vue&type=script&lang=js"
export * from "./ResourcesGoal3a.vue?vue&type=script&lang=js"

import exportComponent from "P:\\htdocs\\we-smile\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__